/* Elegant Barcelona — auto-hide header on downward scroll; restore on upward scroll. */
(function () {
  'use strict';
  var headerSection = document.querySelector('.header-section');
  if (!headerSection || headerSection.dataset.ebGlassScrollReady === 'true') return;
  headerSection.dataset.ebGlassScrollReady = 'true';
  var lastY = Math.max(0, window.scrollY);
  var distance = 0;
  var direction = 0;
  var ticking = false;
  var menuToggle = document.querySelector('.mobile-toggle-wrapper');
  var isMenuOpen = function () {
    return menuToggle && menuToggle.classList.contains('active');
  };
  function refresh() {
    var y = Math.max(0, window.scrollY);
    var delta = y - lastY;
    var currentDirection = Math.sign(delta);
    if (currentDirection !== 0 && currentDirection !== direction) {
      direction = currentDirection;
      distance = 0;
    }
    distance += delta;
    if (y <= 40 || isMenuOpen() || headerSection.contains(document.activeElement)) {
      headerSection.classList.remove('eb-scroll-hidden');
      distance = 0;
    } else if (y > 105 && distance >= 13) {
      headerSection.classList.add('eb-scroll-hidden');
      distance = 0;
    } else if (distance <= -13) {
      headerSection.classList.remove('eb-scroll-hidden');
      distance = 0;
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(refresh);
    }
  }, { passive: true });
  window.addEventListener('pageshow', function () {
    lastY = Math.max(0, window.scrollY);
    distance = 0;
    headerSection.classList.remove('eb-scroll-hidden');
  });
  if (menuToggle && window.MutationObserver) {
    new MutationObserver(function () {
      if (isMenuOpen()) headerSection.classList.remove('eb-scroll-hidden');
    }).observe(menuToggle, { attributes: true, attributeFilter: ['class'] });
  }
})();
